import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'kh-primary-dropdown',
    styleUrls: ['./primary-dropdown.component.less'],
    templateUrl: './primary-dropdown.component.html',
    standalone: false
})
export class PrimaryDropdownComponent<TItem> {

  @Input() public items: TItem[] = [];
  @Input() public getName!: (item: TItem) => string | undefined;
  @Input() public selectedItem: TItem | unknown;
  @Input() public disabled = false;
  @Input() public placeHolder = '';
  @Input() public validationMessages: string[] = [];
  @Input() public displayErrors = false;

  @Output() public readonly itemClick = new EventEmitter<TItem>();

  public onItemClick(item: TItem): void {
    this.selectedItem = item;
    this.itemClick.emit(item);
  }

  public resolveName(item: TItem | unknown): string {
    return item ? this.getName(item as TItem) ?? '' : this.placeHolder;
  }
}
